import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpRequest, HttpErrorResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable()
export class HttpInterceptorService {

  constructor(private router: Router, private snackBar: MatSnackBar) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (!window.navigator.onLine) {
      alert('Подключение к Интернету отсутствует');
      return Observable.throw(new HttpErrorResponse({ error: 'Internet is required.' }));
    } else {
      if (req.url == environment.apiUrl+'Token') {
        localStorage.removeItem('PortalTokenManager');
      }
      let token = localStorage.getItem('PortalTokenManager');
      if (token) {
        let dubReq = req.clone({ headers: req.headers.set('Authorization', `Bearer ${token}`) });
        return next.handle(dubReq).pipe(
          tap(event => {
          }, (err: any) => {
            console.log(err, 'error');
            if (err instanceof HttpErrorResponse) {
              if (err.status === 401) {
                this.router.navigate(['login']);
              }
              else {
                this.snackBar.open( err.error.message + ' Статус ' + err.status, '', {
                  duration: 5000,
                  verticalPosition: 'top',
                  horizontalPosition: 'right',
                  panelClass: ['snackbar-error']
                });
                return;
              }
            }
          })
        );
      } else {
        return next.handle(req).pipe(
          tap(event => {
          }, (err: any) => {
            if (err instanceof HttpErrorResponse) {
              if (err.status === 401) {
                this.router.navigate(['login']);
              }
              else {
                const message = err.error?.error_description ? err.error?.error_description : err.error.message;
                this.snackBar.open(message + ' Статус ' + err.status, '', {
                  duration: 500000,
                  verticalPosition: 'top',
                  horizontalPosition: 'right',
                  panelClass: ['snackbar-error']
                });
                return;
              }
            }
          })
        );
      }
    }
  }

}
